import React, { Component } from 'react';
import ReactTooltip, { Place } from 'react-tooltip';

import { IEPGProgram } from './IEPG';

import styles from './Readjusted.module.css'

interface ReadjustedProps {
    // epg
    epg: IEPGProgram[];
    // Timeline duration
    timelineDuration: number;
    // Timeline start
    timelineStart: Date;
    // Small and big ticks range
    tickRanges: number[];


    // When setting player start
    onSetStart?(start: Date): void;
}

interface ReadjustedState {
    tooltipPlace: Place;
}

export class Readjusted extends Component<ReadjustedProps, ReadjustedState> {

    private container: HTMLDivElement | null;
    private tooltipId = '';

    public constructor(props: ReadjustedProps) {
        super(props);
        this.state = {
            tooltipPlace: 'right',
        }
        this.tooltipId = `readjustedTooltip_${Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)}`;
    }

    public render() {
        this.draw();
        return <div
            className={styles.container}
            onMouseMove={this.onMouseMove.bind(this)}
            ref={(c) => { this.container = c; }}
        >
            {this.draw()}
            <ReactTooltip
                className={styles.tooltip}
                id={this.tooltipId}
                place={this.state.tooltipPlace}
            />

        </div>;
    }


    private draw(): React.ReactNode[] {
        if (this.container === null) {
            return [];
        }
        const elements: React.ReactNode[] = [];

        this.props.epg.forEach((epg: IEPGProgram) => {
            const realStart = new Date(epg.start * 1000);
            let start = realStart;
            const realEnd = new Date(start.getTime() + epg.durationMS);
            let end = realEnd;

            if (
                (realEnd.getTime() <= this.props.timelineStart.getTime()) ||
                (realStart.getTime() >= (this.props.timelineStart.getTime() + this.props.timelineDuration * 1000))
            ) {
                return;
            }

            if (realStart.getTime() <= this.props.timelineStart.getTime()) {
                start = this.props.timelineStart;
            }
            if (realEnd.getTime() >= (this.props.timelineStart.getTime() + (this.props.timelineDuration * 1000))) {
                end = new Date(this.props.timelineStart.getTime() + (this.props.timelineDuration * 1000));
            }

            const left = (start.getTime() - this.props.timelineStart.getTime()) / (this.props.timelineDuration * 1000);
            const width = (end.getTime() - start.getTime()) / (this.props.timelineDuration * 1000);

            elements.push(
                <div
                    className={styles.program}
                    data-for={this.tooltipId}
                    data-html={true}
                    data-tip={epg.title + '<br />' + epg.categoryText}
                    key={`program_${epg.start}_${epg.durationMS}`}
                    onClick={this.clickProgram.bind(this, start)}
                    style={{
                        backgroundColor: this.getReadjustedCategoryColor(epg.categoryText),
                        left: `${left * 100}%`,
                        width: `${width * 100}%`,
                    }}
                >
                    {epg.title}
                </div>
            );
        });
        return elements;
    }


    private getReadjustedCategoryColor(category: string): string {
        switch (category.substr(0, 1)) {
            case 'A': { return '#2BA0FF'; }
            case 'B': { return '#C2BE8C'; }
            case 'C': { return '#F63AFC'; }
            case 'D': { return '#FFDD00'; }
            case 'E': { return '#3EBA00'; }
            case 'F': { return '#B2F202'; }
            case 'G': { return '#FAA5EA'; }
            case 'H': { return '#C375FF'; }
            case 'I': { return '#ABA893'; }
            case 'J': { return '#B8CFDB'; }
            default:
                return '#dddddd';
        }
    }

    private clickProgram(start: Date, ev: MouseEvent): void {
        if (typeof this.props.onSetStart !== 'undefined') {
            ev.preventDefault();
            ev.stopPropagation();
            const s = new Date(start.getTime() + 8000);
            this.props.onSetStart(s);
        }
    }

    private onMouseMove(ev: MouseEvent): void {
        const place = (
            (ev.currentTarget === null) ||
            (typeof (ev.currentTarget as HTMLElement).getBoundingClientRect() === 'undefined') ||
            ((ev.clientX / (ev.currentTarget as HTMLElement).getBoundingClientRect().width) < 0.5)
        ) ?  'right' : 'left';
        this.setState({ ...this.state, tooltipPlace: place });
    }

}
